import { render, staticRenderFns } from "./JobCancel.vue?vue&type=template&id=30ff9924&scoped=true"
import script from "./JobCancel.vue?vue&type=script&lang=ts"
export * from "./JobCancel.vue?vue&type=script&lang=ts"
import style0 from "./JobActions.scss?vue&type=style&index=0&id=30ff9924&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ff9924",
  null
  
)

export default component.exports